import type { MutationFireOutcome } from "~/helpers/offline/classifyMutationFireOutcome";

import snackMessages from "~/helpers/snackMessages";

export type QueueAnnouncementVariant = "error" | "info" | "success";

export interface QueueAnnouncement {
	message: string;
	variant: QueueAnnouncementVariant;
}

export const QUEUED_VARIANT: QueueAnnouncementVariant = "info";

export const RETRYING_VARIANT: QueueAnnouncementVariant = "info";

export const announceRetainedForRetry = (entity: string): QueueAnnouncement => ({
	message: snackMessages.retrying(entity),
	variant: RETRYING_VARIANT
});

const announceQueueOutcome = <TPayload>(
	outcome: MutationFireOutcome<TPayload>,
	entity: string,
	settledMessage?: string
): QueueAnnouncement => {
	if (outcome.outcome === "failed") return { message: outcome.errorMessage, variant: "error" };
	if (outcome.outcome === "queued") return { message: snackMessages.savedQueued(entity), variant: QUEUED_VARIANT };
	return { message: settledMessage ?? snackMessages.saveSuccess(entity), variant: "success" };
};

export default announceQueueOutcome;
